import z from 'zod/v4';
import { Currency as PaymentCurrency, ExportTypeSchema } from '../../index.js';
import { CaseVoucherFilterSchema, CaseVoucherSource, State as VoucherState, } from './index.js';
export const MAX_CASE_VOUCHER_EXPORT = 10000;
export var CaseVoucherExportField;
(function (CaseVoucherExportField) {
    CaseVoucherExportField["Id"] = "id";
    CaseVoucherExportField["Creditor"] = "creditor";
    CaseVoucherExportField["CreditorReference"] = "creditorReference";
    CaseVoucherExportField["CustomerReference"] = "customerReference";
    CaseVoucherExportField["CaseId"] = "caseId";
    CaseVoucherExportField["VoucherId"] = "voucherId";
    CaseVoucherExportField["VoucherReferenceId"] = "voucherReferenceId";
    CaseVoucherExportField["State"] = "state";
    CaseVoucherExportField["Account"] = "account";
    CaseVoucherExportField["AccountId"] = "accountId";
    CaseVoucherExportField["Type"] = "type";
    CaseVoucherExportField["Source"] = "source";
    CaseVoucherExportField["Text"] = "text";
    CaseVoucherExportField["CreatedAt"] = "createdAt";
    CaseVoucherExportField["Date"] = "date";
    CaseVoucherExportField["BookingDate"] = "bookingDate";
    CaseVoucherExportField["Amount"] = "amount";
    CaseVoucherExportField["Currency"] = "currency";
    CaseVoucherExportField["VoucherType"] = "voucherType";
    CaseVoucherExportField["ExpirationDate"] = "expirationDate";
    CaseVoucherExportField["IrrecoverableDate"] = "irrecoverableDate";
    CaseVoucherExportField["Expired"] = "expired";
    CaseVoucherExportField["ExpiredAmount"] = "expiredAmount";
    CaseVoucherExportField["IrrecoverableAmount"] = "irrecoverableAmount";
    CaseVoucherExportField["OriginalAmount"] = "originalAmount";
})(CaseVoucherExportField || (CaseVoucherExportField = {}));
export const caseVoucherExportFields = Object.values(CaseVoucherExportField);
export const depositExportFields = caseVoucherExportFields.filter((field) => ![
    CaseVoucherExportField.Id,
    CaseVoucherExportField.VoucherType,
    CaseVoucherExportField.ExpirationDate,
    CaseVoucherExportField.IrrecoverableDate,
    CaseVoucherExportField.Expired,
    CaseVoucherExportField.ExpiredAmount,
    CaseVoucherExportField.IrrecoverableAmount,
    CaseVoucherExportField.OriginalAmount,
].includes(field));
export const voucherExportFields = [
    CaseVoucherExportField.Id,
    CaseVoucherExportField.CaseId,
    CaseVoucherExportField.VoucherType,
    CaseVoucherExportField.Date,
    CaseVoucherExportField.Text,
    CaseVoucherExportField.Source,
    CaseVoucherExportField.State,
    CaseVoucherExportField.Amount,
    CaseVoucherExportField.Currency,
    CaseVoucherExportField.ExpirationDate,
    CaseVoucherExportField.IrrecoverableDate,
];
export const caseVoucherExportLabels = (lang) => ({
    id: lang.misc.id,
    creditor: lang.caseVouchers.creditor,
    creditorReference: lang.caseVouchers.creditorReference,
    customerReference: lang.caseVouchers.customerReference,
    caseId: lang.caseVouchers.caseId,
    voucherId: lang.caseVouchers.voucherId,
    voucherReferenceId: lang.caseVouchers.voucherReferenceId,
    state: lang.misc.state,
    account: lang.caseVouchers.account,
    accountId: lang.caseVouchers.accountId,
    type: lang.misc.type,
    source: lang.caseVouchers.source,
    text: lang.misc.text,
    createdAt: lang.misc.createdAt,
    date: lang.misc.date,
    bookingDate: lang.caseVouchers.bookingDate,
    amount: lang.economy.amount,
    currency: lang.economy.currency,
    voucherType: lang.misc.type,
    expirationDate: lang.caseVouchers.expirationDate,
    irrecoverableDate: lang.caseVouchers.irrecoverableDate,
    expired: lang.caseVouchers.expired,
    expiredAmount: lang.economy.expiredAmount,
    irrecoverableAmount: lang.economy.irrecoverableAmount,
    originalAmount: lang.economy.originalAmount,
});
export const CaseVoucherExportColumnSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('field'),
        field: z.enum(CaseVoucherExportField),
        label: z.string().trim().min(1).max(200).optional(),
    }),
    z.object({
        type: z.literal('property'),
        propertyTypeId: z.uuid(),
        label: z.string().trim().min(1).max(200).optional(),
    }),
]);
// The table's GET filters encode arrays as JSON; export requests have a JSON body.
export const CaseVoucherExportFilterSchema = CaseVoucherFilterSchema.extend({
    expired: z.boolean().optional(),
    exported: z.boolean().optional(),
    voucherTypeIds: z.array(z.uuid()).min(1).optional(),
    currencies: z.array(z.enum(PaymentCurrency)).min(1).optional(),
    sources: z.array(z.enum(CaseVoucherSource)).min(1).optional(),
    states: z.array(z.enum(VoucherState)).min(1).optional(),
});
export const CaseVoucherExportSchema = z
    .object({
    ids: z.array(z.uuid()).min(1).max(MAX_CASE_VOUCHER_EXPORT).optional(),
    transactionAccountId: z.uuid().optional(),
    filter: CaseVoucherExportFilterSchema.optional(),
    markAsExported: z.boolean().optional(),
    deposits: z.boolean().optional(),
    columns: z.array(CaseVoucherExportColumnSchema).min(1).max(100).optional(),
})
    .and(ExportTypeSchema)
    .refine((body) => body.ids != null
    ? body.transactionAccountId == null && body.filter == null
    : body.transactionAccountId != null || body.filter != null, {
    message: 'Choose either voucher ids or table filters',
});
//# sourceMappingURL=export.js.map